import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconPrinterOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M7.5 3v3H6V3a1.5 1.5 0 0 1 1.5-1.5h9A1.5 1.5 0 0 1 18 3v3h-1.5V3zm9.115 11.25c.765 0 1.385.74 1.385 1.65v5.5c0 .608-.414 1.1-.923 1.1H6.923c-.51 0-.923-.492-.923-1.1v-6.05c0-.607.414-1.1.923-1.1zm-.115 5.036V15.75h-9V21h9zM1.5 7.5h21c.828 0 1.5.655 1.5 1.463V19.5h-4v-1.462h2.5V8.963h-21v9.075H4V19.5H0V8.963C0 8.155.672 7.5 1.5 7.5" /></svg>
);
